import { useMediaQuery } from '@mui/material';
import { IBudgetSummary } from '../../createAndEdit/types';
import DetailSummaryMobile from './mobile/DetailSummaryMobile';

interface IDetailSummaryProps {
  summary: IBudgetSummary;
  counterProposalAcceptedAt?: string | null;
  isMobile?: boolean;
}

const DetailSummary = (props: IDetailSummaryProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  
  if (isMobile) {
    return (
      <DetailSummaryMobile
        summary={props.summary}
        counterProposalAcceptedAt={props.counterProposalAcceptedAt}
      />
    );
  }
  
  const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  const total = props.summary.totalToPay - (props.summary.subscriptionBalanceApplied || 0);

  return (
    <div className="border border-gray-300 rounded-md p-4">
      <div className="flex flex-col gap-3">
        <div className="flex flex-row items-center justify-end gap-2 text-gray-600 pr-2 text-size-18">
          <span>Subtotal:</span>
          <span>{formatCurrency(props.summary.subtotal)}</span>
        </div>
        <div className="flex flex-row items-center justify-end gap-2">
          <span className="text-green-600">Descontos:</span>
          <span className="font-bold text-green-600">{formatCurrency(props.summary.discounts)}</span>
        </div>
        {props.summary.subscriptionBalanceApplied ? <div className="flex flex-row items-center justify-end gap-2">
          <span className="text-green-600">Saldo do plano utilizado:</span>
          <span className="font-bold text-green-600">{formatCurrency(props.summary.subscriptionBalanceApplied)}</span>
        </div> : null}
        <div className={`flex flex-row items-center justify-end gap-2 text-gray-600 pr-2 text-size-18 font-bold ${props.counterProposalAcceptedAt ? 'line-through' : ''}`}>
          <span>Valor a ser pago:</span>
          <span>{formatCurrency(props.summary.totalToPay)}</span>
        </div>
        {props.counterProposalAcceptedAt && (
          <div className="flex flex-row items-center justify-end gap-2">
            <span className="font-bold text-size-16">Valor a ser pago:</span>
            <span className="font-bold text-size-16">{formatCurrency(props.summary.counterProposalValue || 0)}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DetailSummary;


